import styled from "styled-components";
import {  Row } from "react-bootstrap";

export const NotRow = styled(Row)`
    &:hover {
        transition: all 0.3s ease-in-out;
        background: #cdcdcd;
    }
`;

export const Not1Row = styled(Row)`
    background: #eeeeee;
    display: table-row;
    &:hover {
        transition: all 0.3s ease-in-out;
        background: #cdcdcd;
    }
`;

export const DeleteButton = styled.div`
    text-align: center;
    justify-content: center;
    display: flex;
    align-self: center;
    height: 20px;
    width: 10px;
    position: relative;
    top: 18px;
    margin: 0px 5px;
    &:hover {
        cursor: pointer;
        background: #b9b9b9;
    }
`;